import React from "react";
import ImageAdvert from "../../images/advrt-logo.png";
import LazyLoad from 'react-lazyload';


function AdvertBlock(props) {

  return (
    <div className="advert-section section-gap" id={props.id ? props.id : ''}>
      <div className="container">
        <div className="advert-section-inner">
            <div className="image-leftbar">
            <LazyLoad>
              <img src={ ImageAdvert }  alt="retail digital transformation" title="Retail Transformation" />
            </LazyLoad>
            </div>
            <div className="intro-rightbar">
              <h3>Digital transformation is expected to add $100 <br/>trillion to the world economy by 2025. </h3>
            </div>
          </div>
      </div>
    </div>
  );
}

export default AdvertBlock; 